import { useTranslation } from "react-i18next";
import { IconlyMenuCloseLeft, IconlyMenuOpenRight } from "@/core/assets/icons";
import WosKeyLogo from "@/core/assets/wos-key.svg?react";
import {
  SidebarHeader as SidebarHeaderUI,
  useSidebar,
} from "@/core/components/ui/sidebar";
import { EVENTS, useActionsTrack } from "@/core/services/menu-analytics";

export function WosSidebarHeader() {
  const { state, toggleSidebar, isMobile } = useSidebar();
  const [translate] = useTranslation(["core"]);
  const { onActionClick } = useActionsTrack();

  const isCollapsed = state === "collapsed";

  const onToggle = () => {
    onActionClick(
      (isCollapsed
        ? "MENU_SIDEBAR_EXPAND_CLICK"
        : "MENU_SIDEBAR_COLLAPSE_CLICK") as keyof typeof EVENTS,
      "MENU",
    );
    toggleSidebar();
  };

  // Compactado o sidebar tem 3rem (48px): px-4 deixaria só 16px úteis e
  // esmagava o ícone do toggle — por isso o padding encolhe junto.
  return (
    <SidebarHeaderUI
      className={`gap-0 border-b border-sidebar-border py-4 ${
        isCollapsed ? "px-1" : "px-4"
      }`}
    >
      <div
        className={`flex items-center ${isCollapsed ? "justify-center" : "justify-between"}`}
      >
        <div className="flex items-center gap-3">
          <WosKeyLogo className="size-[34px] shrink-0" />
          {!isCollapsed && (
            <div className="flex flex-col justify-center">
              <span className="font-sans text-base font-semibold leading-tight text-primary">
                {translate("app-name")}
              </span>
              <span className="font-body text-xs font-medium leading-tight text-muted-foreground">
                {translate("app-name-subtitle")}
              </span>
            </div>
          )}
        </div>

        {!isMobile && !isCollapsed && (
          <button
            type="button"
            aria-label={translate("app-menu-collapse") as string}
            onClick={onToggle}
            className="shrink-0 rounded-md p-1 hover:bg-sidebar-accent [&>svg]:size-5 [&>svg]:shrink-0"
            data-testid="wos-sidebar-toggle"
          >
            <IconlyMenuCloseLeft size={20} color="#000" />
          </button>
        )}
      </div>

      {!isMobile && isCollapsed && (
        <button
          type="button"
          aria-label={translate("app-menu-expand") as string}
          onClick={onToggle}
          className="mt-2 flex shrink-0 justify-center rounded-md p-1 hover:bg-sidebar-accent [&>svg]:size-5 [&>svg]:shrink-0"
          data-testid="wos-sidebar-toggle"
        >
          <IconlyMenuOpenRight size={20} color="#000" />
        </button>
      )}
    </SidebarHeaderUI>
  );
}
